import { useRouter } from 'next/router'
import { FeatureFlag } from 'src/config/featureFlags'
import { appRoutes } from 'src/constants/appRoutes'
import { useFeatureFlag } from 'src/hooks/useFeatureFlag'
import SubMenuItems from './SubMenuItems'
import { SubMenuType, SubRoute } from './SubMenuItems.types'

const SubMenu = ({ selectedKeys }: SubMenuType) => {
    const { isEnabled: isDynamicSubtypeManagementEnabled } = useFeatureFlag(
        FeatureFlag.DYNAMIC_SUBTYPE_MANAGEMENT_ENABLED
    )
    const subRoutes: SubRoute[] = [
        {
            pathname: appRoutes.placeholders.path,
            subpaths: [
                {
                    href: `${appRoutes.placeholderConfigPath.path}`,
                    displayLabel: 'Configurations',
                    key: appRoutes.placeholderConfigPath.key,
                },
                { href: appRoutes.imagePlaceholders.path, displayLabel: 'Image', key: appRoutes.imagePlaceholders.key },
                {
                    href: `${appRoutes.conditionConfigPath.path}`,
                    displayLabel: 'Conditions',
                    key: appRoutes.conditionConfigPath.key,
                },
                {
                    href: appRoutes.assets.path,
                    displayLabel: 'Assets',
                    key: appRoutes.assets.key,
                },
            ],
        },
        {
            pathname: appRoutes.contracts.path,
            subpaths: [
                { href: appRoutes.templates.path, displayLabel: 'Contract templates', key: appRoutes.templates.key },
                {
                    href: appRoutes.pvcontracts.path,
                    displayLabel: 'PV Contract groups',
                    key: appRoutes.pvcontracts.key,
                },
                {
                    href: appRoutes.hpContracts.path,
                    displayLabel: 'HP Contract groups',
                    key: appRoutes.hpContracts.key,
                },
                {
                    href: appRoutes.subtypes.path,
                    displayLabel: 'Subtypes',
                    key: appRoutes.subtypes.key,
                },
            ],
        },
        {
            pathname: appRoutes.presentations.path,
            subpaths: [
                {
                    href: appRoutes.presentationTemplates.path,
                    displayLabel: 'Presentation templates',
                    key: appRoutes.presentationTemplates.key,
                },
                {
                    href: appRoutes.presentationGroups.path,
                    displayLabel: 'Presentation groups',
                    key: appRoutes.presentationGroups.key,
                },
                ...(isDynamicSubtypeManagementEnabled
                    ? [
                          {
                              href: appRoutes.presentationSubtypes.path,
                              displayLabel: 'Subtypes',
                              key: appRoutes.presentationSubtypes.key,
                          },
                      ]
                    : []),
            ],
        },
    ]
    const router = useRouter()
    const { asPath: routerPathName } = router
    const subRoute = subRoutes.find((subroute) => routerPathName.startsWith(subroute.pathname))

    if (!subRoute) {
        return null
    }

    return <SubMenuItems pathname={subRoute.pathname} menuItems={subRoute.subpaths} selectedKeys={selectedKeys} />
}

export default SubMenu
